// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
import * as config from './shared/config/config';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import HealthService from './pages/admin/health/health.service';
import MetricsService from './pages/admin/metrics/metrics.service';
import LogsService from './pages/admin/logs/logs.service';
import ConfigurationService from './pages/admin/configuration/configuration.service';
import ActivateService from './pages/account/activate/activate.service';
import UserManagementService from './pages/admin/user-management.service';
import RegisterService from './shared/utility-services/register.service';
import LoginService from './pages/account/login.service';
import AccountService from './pages/account/account.service';
import * as GmapVue from 'gmap-vue';
import GmapCluster from 'gmap-vue/dist/components/cluster';

import '../content/scss/vendor.scss';
import TranslationService from '@/shared/locale/translation.service';

import UserOAuth2Service from '@/shared/services/user.oauth2.service';
/* tslint:disable */

import RestaurantService from '@/shared/services/restaurant.service';
import RestaurantWorkingTimesService from '@/shared/services/restaurant-working-times.service';
import RestaurantCategoryService from '@/shared/services/restaurant-category.service';
import DiscountService from '@/shared/utility-services/discount.service';
import DeliverySpecService from '@/shared/services/delivery-spec.service';
import MenuCategorySuggestionService from '@/shared/utility-services/menu-category-suggestion.service';
import MenuCategoryService from '@/shared/services/menu-category.service';
import MenuService from '@/shared/utility-services/menu.service';
import MenuVariantService from '@/shared/utility-services/menu-variant.service';
import AddonCategorySuggestionService from '@/shared/utility-services/addon-category-suggestion.service';
import AddonSuggestionService from '@/shared/utility-services/addon-suggestion.service';
import AddonCategoryService from '@/shared/utility-services/addon-category.service';
import AddonService from '@/shared/utility-services/addon.service';
import MultiLanguageService from '@/shared/utility-services/multi-language.service';
import PriceService from '@/shared/utility-services/price.service';
import AvailabilityService from '@/shared/utility-services/availability.service';
import MarketerService from '@/pages/marketer/marketer.service';
import RatingService from '@/shared/services/rating.service';
import CustomerService from '@/shared/utility-services/customer.service';
import AddressService from '@/shared/utility-services/address.service';
import AddressValidationService from '@/shared/services/address-validation.service';
import PaymentTypeService from '@/shared/services/payment-type.service';
import ProductInfoAdditiveService from '@/shared/services/product-info-additive.service';
import RegistrationsService from '@/pages/account/registrations.service';
import MessageService from '@/shared/utility-services/message.service';
import GeoLocationService from '@/pages/core/geolocation/geolocation.service';
import InputValidationsService from '@/shared/services/input-validations.service';
import BillingsService from '@/shared/services/billings.service';
import ReportService from '@/shared/services/report.service';
import PaymentService from '@/shared/services/payment.service';

import FlagIcon from 'vue-flag-icon';
import VueCookies from 'vue-cookies';
import { GOOGLE_API_KEY } from '@/constants';
import { Authority } from './shared/security/authority';
import ProductInfoAllergenService from './shared/services/product-info-allergen.service';
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initVuetify(Vue);
Vue.use(Vue2Filters);
Vue.use(FlagIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
Vue.component('GmapCluster', GmapCluster);
const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);
const vuetify = config.initVuetify(Vue);

Vue.use(VueCookies);
Vue.$cookies.config('30d');

Vue.use(GmapVue, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: 'places',
  },

  installComponents: true,
});

const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        // if (to.name === 'Marketer') {
        //   next('/marketer/anmelden');
        if (to.name === 'Restaurant') {
          next('/restaurant/anmelden');
        } else if (to.name === 'Support') {
          next('/support/anmelden');
        } else if (to.name === 'Admin') {
          next('/admin/anmelden');
        } else {
          sessionStorage.setItem('requested-url', to.fullPath);
          next('/forbidden');
        }
      } else {
        // if (to.name === 'Marketer' && !accountService.userAuthorities.includes(Authority.MARKETER)) {
        //   next('/marketer/anmelden');
        if (to.name === 'Restaurant' && !accountService.userAuthorities.includes(Authority.RESTAURANT)) {
          next('/restaurant/anmelden');
        } else if (to.name === 'Support' && !accountService.userAuthorities.includes(Authority.SUPPORT)) {
          next('/support/anmelden');
        } else if (to.name === 'Admin' && !accountService.userAuthorities.includes(Authority.ADMIN)) {
          next('/admin/anmelden');
        } else {
          next();
        }
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    userOAuth2Service: () => new UserOAuth2Service(),
    translationService: () => translationService,
    restaurantService: () => new RestaurantService(),
    restaurantWorkingTimesService: () => new RestaurantWorkingTimesService(),
    restaurantCategoryService: () => new RestaurantCategoryService(),
    discountService: () => new DiscountService(),
    deliverySpecService: () => new DeliverySpecService(),
    menuCategorySuggestionService: () => new MenuCategorySuggestionService(),
    menuCategoryService: () => new MenuCategoryService(),
    menuService: () => new MenuService(),
    menuVariantService: () => new MenuVariantService(),
    addonCategorySuggestionService: () => new AddonCategorySuggestionService(),
    addonSuggestionService: () => new AddonSuggestionService(),
    addonCategoryService: () => new AddonCategoryService(),
    addonService: () => new AddonService(),
    multiLanguageService: () => new MultiLanguageService(),
    priceService: () => new PriceService(),
    availabilityService: () => new AvailabilityService(),
    marketerService: () => new MarketerService(),
    ratingService: () => new RatingService(),
    billingsService: () => new BillingsService(),
    reportService: () => new ReportService(),
    customerService: () => new CustomerService(),
    addressService: () => new AddressService(),
    addressValidationService: () => new AddressValidationService(),
    paymentTypeService: () => new PaymentTypeService(),
    productInfoAllergenService: () => new ProductInfoAllergenService(),
    productInfoAdditiveService: () => new ProductInfoAdditiveService(),
    messageService: () => new MessageService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    registrationsService: () => new RegistrationsService(),
    geoLocationService: () => new GeoLocationService(),
    inputValidationsService: () => new InputValidationsService(),
    paymentService: () => new PaymentService(),
  },
  i18n,
  store,
  vuetify,
});

export { i18n };
